var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Loading',{attrs:{"spin":!_vm.isRouterResolved}}),_c('router-view'),_c('notifications',{attrs:{"group":"noti-popup","position":"top center","max":1,"width":"96%","duration":3000}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }